<template>
  <b-card body-class="p-3">
    <div v-if="isLoading" class="text-center text-danger my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Lade Details...</strong>
    </div>
    <b-row v-if="!isLoading">
      <b-col cols="10" class="d-lg-none">
        <dl class="row mb-3">
          <dt class="col-5">Verderblich:</dt>
          <dd class="col-7 mb-0">{{ formatIngredientPerishable(item.ingredient_perishable) }}</dd>
          <dt class="col-5">Zoll:</dt>
          <dd class="col-7 mb-0">{{ formatCustomsCategory(item.customs_category) }}</dd>
        </dl>
      </b-col>
      <b-col cols="2" class="d-lg-none"><i class="float-right fas fa-times" @click="hideDetails"></i></b-col>
      <b-col md="6">
        <h5>{{ item.ingredient_title }} wird benötigt für:</h5>
        <b-table-simple borderless>
          <b-tbody>
            <b-tr v-for="(source, index) in item.details.sources" v-bind:key="index">
              <b-td>
                <span v-if="source.source_type === 'recipe'">Rezept:</span>
                <span v-if="source.source_type === 'material-list'">Materialliste:</span>
                <span v-if="source.source_date ">{{ formatDate(source.source_date.date, 'D.M.Y') }} -</span>
                <span>{{ source.source_title }}</span>
              </b-td>
              <b-td class="text-right">{{ formatAmountNeeded(source.amount_needed, 'amount_needed', item) }} {{ item.base_unit_title }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
      <b-col md="5" offset-md="1">
        <b-btn v-if="canEdit" class="float-right" size="xs" @click="resetDelta" :disabled="isSaving">Zurücksetzen</b-btn>
        <h5>Berechnung:</h5>
        <b-table-simple borderless class="mb-0">
          <b-tbody>
            <b-tr>
              <b-td>Berechnete Menge:</b-td>
              <b-td class="text-right">{{ formatAmountNeeded(item.amount_needed, 'amount_needed', item) }} {{ item.base_unit_title }}</b-td>
            </b-tr>
            <b-tr>
              <b-td>Vorhandene Reste:</b-td>
              <b-td class="text-right">- {{ formatAmountNeeded(item.details.amount_available || 0, 'amount_available', item) }} {{ item.base_unit_title }}</b-td>
            </b-tr>
            <b-tr>
              <b-td>Eigene Anpassung:</b-td>
              <b-td class="text-right">
                {{ localDelta < 0 ? '-' : '+' }}
                {{ formatAmountNeeded(Math.abs(localDelta), null, item) }} {{ item.base_unit_title }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <div class="calculation-sum">
          <div class="float-left">Summe:</div>
          <div class="float-right">
            <b-input-group size="sm" v-if="canEdit">
              <b-form-input type="number" v-model="localShopping"
                            :step="Math.pow(10, -item.base_unit_precision)"
                            @keydown.enter.native="submitDelta" :readonly="isSaving"
                            class="text-right"></b-form-input>
              <b-input-group-append>
                <b-input-group-text>{{ item.base_unit_title }}</b-input-group-text>
                <b-btn class="save-row-details" @click="submitDelta" variant="primary" :disabled="isSaving">
                  <i v-if="!isSaving" class="fas fa-save" />
                  <b-spinner v-if="isSaving" small variant="light"></b-spinner>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <span v-if="!canEdit">
              {{ formatAmountNeeded(item.amount_shopping, null, item) }} {{ item.base_unit_title }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import HelperMixin from "./HelperMixin"
const axios = require('axios')

export default {
  props: [ 'item', 'filterOptions', 'canEdit', 'apiUrl' ],
  mixins: [ HelperMixin ],
  data() {
    return {
      isLoading: false,
      isSaving: false,
      localShopping: 0,
    }
  },
  computed: {
    localDelta() {
      return (this.item.amount_needed - (this.item.details.amount_available || 0) - this.localShopping) * -1
    }
  },
  watch: {
    'item': {
      'handler': function() {
        this.setLocalAmountShopping(this.item.amount_shopping)
      },
      'deep': true
    }
  },
  mounted() {
    if (!this.item.details || this.item.details.length === 0) { // if details not available yet, load them
      this.isLoading = true
      let promise = axios.get(this.apiUrl, {
        params: {
          id: this.item.ingredient_id
        }
      })
      return promise.then((result) => {
        this.$set(this.item, 'details', result.data)
        this.isLoading = false
        this.setLocalAmountShopping(this.item.amount_shopping)
      }).catch(error => {
        // maybe handle errors somehow?
      })
    } else {
      this.setLocalAmountShopping(this.item.amount_shopping)
    }
  },
  methods: {
    setLocalAmountShopping(value) {
      this.localShopping = Math.round(value * Math.pow(10, this.item.base_unit_precision)) / Math.pow(10, this.item.base_unit_precision)
    },
    hideDetails(e) {
      this.$set(this.item, '_showDetails', false)
    },
    submitDelta(e) {
      this.isSaving = true
      axios.put(this.apiUrl, {
        amount_delta: this.localDelta,
      }, {
        params: {
          id: this.item.ingredient_id,
        }
      }).then((result) => {
        this.$set(this.item, 'amount_shopping', result.data.amount_shopping)
        this.$set(this.item.details, 'amount_available', result.data.amount_available)
        this.setLocalAmountShopping(result.data.amount_shopping)
        this.isSaving = false
      }).catch(error => {
        // maybe handle errors somehow?
      })
    },
    resetDelta(e) {
      this.isSaving = true
      axios.put(this.apiUrl, {
        amount_delta: 0,
      }, {
        params: {
          id: this.item.ingredient_id,
        }
      }).then((result) => {
        this.$set(this.item, 'amount_shopping', result.data.amount_shopping)
        this.$set(this.item.details, 'amount_available', result.data.amount_available)
        this.setLocalAmountShopping(result.data.amount_shopping)
        this.isSaving = false
      }).catch(error => {
        // maybe handle errors somehow?
      })
    }
  }
}
</script>

<style scoped>
  table tr {
    background: transparent !important;
  }
  table td {
    padding: 0.1rem 0;
  }
  .calculation-sum {
    border-top: double 1px #000;
    font-weight: bold;
    line-height: 2rem;
    padding-top: 0.5rem;
    margin-top: 0.3rem;
  }
  .calculation-sum input {
    max-width: 5rem;
  }
  .save-row-details {
    width: 2rem;
  }
</style>